<template>
    <div class="ml80 mt48 full-w">
        <p class="code-info">
            <span v-if="codeNum<=0" class="text-color-gray">不需要打码</span>
            <span v-else class="text-color-error">缺码啦！需要提交3个验证码</span>
        </p>
        <div class="plat-list mt30">
            <el-button :type="curPlat==plat.name?'primary':''" v-for="plat in platList" :key="plat.name" @click="changePlat(plat)">{{plat.displayName}}({{plat.code}})</el-button>
        </div>
        <div class="captcha-wrap mt20">
            <div id="captcha"></div>
        </div>
        <div class="submit-wrap mt20">
            <div class="tac">
                <el-button type="primary" class="ml20 mr20">提交</el-button>
                <el-button class="ml20 mr20">刷新</el-button>
            </div>
        </div>
        <div class="notice-wrap">
            <p class="mt10 mb10">缺码通知人：</p>
            <div>
                <ESelect v-model="notice" multiple placeholder="请选择" class="inline-block" style="width: 400px;">
                    <el-option
                        v-for="item in userList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </ESelect>
                <el-button type="primary" class="ml20 mr20">编辑</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "spiderPage",
        data(){
            return {
                codeNum:1,
                platList:[
                    {
                        name:'oppo',
                        displayName:'OPPO',
                        code:2,
                    },
                    {
                        name:'huawei',
                        displayName:'华为',
                        code:3,
                    },
                ],
                curPlat:'oppo',
                userList:[{
                    value: '选项1',
                    label: '黄金糕'
                }, {
                    value: '选项2',
                    label: '双皮奶'
                }, {
                    value: '选项3',
                    label: '蚵仔煎'
                }, {
                    value: '选项4',
                    label: '龙须面'
                }, {
                    value: '选项5',
                    label: '北京烤鸭'
                }],
                notice:[],
            }
        },
        methods:{
            changePlat(plat){
                this.curPlat = plat.name;
            },
        },
    }
</script>

<style scoped>
    .captcha-wrap{
        min-height: 120px;
        background-color: #ccc;
        width: 500px;
    }
    .submit-wrap{
        width: 500px;
    }
</style>
